<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType } from 'vue';

type AdditionalProps = {
    integrationId: string;
};

defineProps({
    params: {
        type: Object as PropType<ICellRendererParams & AdditionalProps>,
        required: true
    }
});
</script>

<template>
    <div class="flex-container align-middle align-center height-100">
        <SIcon
            v-if="params.integrationId == null"
            v-tooltip="$t('module.integrations.importTypeSalaryFile')"
            icon="FileInput"
        />
        <SIcon
            v-else
            v-tooltip="$t('module.integrations.importTypeIntegration')"
            icon="Workflow"
        />
    </div>
</template>

<style lang="scss" scoped>
.sy-four-human-icon,
.sy-sftp-icon,
.sy-visma-icon,
.sy-hogia-icon,
.sy-sysarb-logo,
.sy-kombo-icon,
.sy-agda-icon {
    height: 20px;
}

.sy-fortnox-icon,
.sy-sympa-icon {
    height: 15px;
}
</style>
